/** Small app brand lockup: seal + "UNM · Electrical". */
export default function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brandmark">
      <img src="/logo.png" alt="" />
      {!compact && (
        <span>
          <strong>UNM</strong> · Electrical
        </span>
      )}
    </div>
  );
}
